"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetStepPlugin_1 = require("auto-widget-framework/src/Plugin/WidgetStep/WidgetStepPlugin");
const FormHandlerEvent_1 = require("../../PluginType/FormHandler/FormHandlerEvent");
const WidgetError_1 = require("auto-widget-framework/src/Error/WidgetError");
const WidgetEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/WidgetEvents");
class WidgetFormStepBase extends WidgetStepPlugin_1.default {
    constructor(definition, widgetConfig, state, eventContext, ractiveWrapper, formHandlerProvider) {
        super(definition, widgetConfig, state, eventContext, ractiveWrapper);
        if (!definition.getFormId || !definition.getFormId()) {
            throw new WidgetError_1.default(`Form based widget steps must define their form handler in plugin definition.`);
        }
        this.formHandlerProvider = formHandlerProvider;
    }
    /**
     * @inheritDoc
     * @see IContainerInjection
     */
    static create(definition, widgetConfig, state, eventContext, container) {
        return new this(definition, widgetConfig, state, eventContext, container.get("ractive_wrapper"), container.get("plugin.provider.form_handler"));
    }
    /**
     * @inheritDoc
     */
    registerHandlers() {
        const formSelector = "#" + this.widgetConfig.getContainerId() + " form";
        this.form = this.formHandlerProvider.create(this.definition.getFormId(), formSelector);
        this.form.on(FormHandlerEvent_1.FormHandlerEvent.ERROR, (error) => this.eventContext.emit(WidgetEvents_1.WidgetEvents.INTERNAL_ERROR, error));
        this.form.on(FormHandlerEvent_1.FormHandlerEvent.SUBMITTED, (data, action) => {
            try {
                if (data.should_select_before_submit) {
                    return;
                }
                return this.submit(data, action);
            }
            catch (error) {
                this.eventContext.emit(WidgetEvents_1.WidgetEvents.INTERNAL_ERROR, error);
            }
        });
        this.initializeForm();
        this.updateFormListener = () => this.form.updateFormFields();
        this.state.on('change', this.updateFormListener);
    }
    /**
     * Initializes the form plugin.
     */
    initializeForm() {
        this.form.initialize();
    }
    /**
     * Handles the submit of the step`s form.
     *
     * @param data
     * @param action
     * @return {Promise | void}
     */
    submit(data, action) {
        throw new WidgetError_1.default(`Submit must be implemented for form steps.`);
    }
    onVehicleSelect(carIndex) {
        throw new WidgetError_1.default(`onVehicleSelect must be implemented for form steps.`);
    }
    destroy() {
        return super.destroy().then(() => {
            this.state.off('change', this.updateFormListener);
        });
    }
}
exports.default = WidgetFormStepBase;
